import { ConsumerPostSubmissionOffersView } from './components/consumer-post-submission-offers-view/consumer-post-submission-offers-view.component'

export const ConsumerPostSubmissionOffers = () => {
  return <ConsumerPostSubmissionOffersView />
}
